/*
IMPORTANT NOTE: don't remove from first line
import dictionary from "configs/dictionary";
WHEN GATSBY RUNS WE NEED TO IMPORT THE DICTIONARY AS FIRST FILE OF THE TEMPLATE
*/
import "configs/dictionary";
import { HeadConfig } from "types/types";
import { PageExtraProps, SettingsPageExtraWithConfig } from "types/pages/types";
import { graphql } from "gatsby";
import { logDebug } from "helpers/generic";
import { normalizeCfJsonData } from "components/HeaderNew/HeaderFull/CfHeaderMenuFull/CfHeaderMenu";
import Head from "components/Head";
import Layout from "components/Layouts/LayoutDefault";
import React from "react";
import templates from "./templates";

const PageTemplate = (props: PageExtraProps) => {
  logDebug("p->->", props);

  const { data, pageContext, location } = props;
  const { contentfulPageExtraV2, contentfulPageExtraConfigsV2 } = data;
  const {
    settings,
    seo,
    hasBreadcrumb,
    templateSlug,
    jsonLd,
    bannerApp,
    bannerPopup,
  } = contentfulPageExtraV2;
  const { menu, menuNavigation, cookieDisclaimer } =
    contentfulPageExtraConfigsV2;
  const { pageHrefLang, lang, breadcrumb } = pageContext;
  const settingsPageExtra: SettingsPageExtraWithConfig = settings[0];

  const headConfig: HeadConfig = {
    pageHrefLang,
    lang,
    robots: settingsPageExtra.metaRobots,
    seo: seo[0],
    location,
    jsonLd: jsonLd?.internal.content,
  };

  logDebug("page-> ", contentfulPageExtraV2);
  logDebug("page Config-> ", contentfulPageExtraConfigsV2);
  logDebug("constex ", pageContext);

  const Component = templates[templateSlug];

  // NOTE: doesn't come from cf settingsPageExtra but from contentfulPageExtraConfigs
  if (cookieDisclaimer) {
    settingsPageExtra.cookieDisclaimer = cookieDisclaimer;
  }

  return (
    <>
      <Head headConfig={headConfig} />
      <Layout
        bannerApp={bannerApp?.[0]}
        bannerPopup={bannerPopup?.[0]}
        headConfig={headConfig}
        header={menuNavigation}
        settings={settings[0]}
        dataJsonMenu={menu}
      >
        <Component
          page={contentfulPageExtraV2}
          breadcrumb={hasBreadcrumb ? breadcrumb : undefined}
        />
      </Layout>
    </>
  );
};

export default PageTemplate;

export const pageQuery = graphql`
  query ($id: String!, $lang: String!, $templateSlug: String!) {
    contentfulPageExtraV2(id: { eq: $id }, node_locale: { eq: $lang }) {
      ... on ContentfulPageExtraV2 {
        ...PageExtraV2
      }
    }
    contentfulPageExtraConfigsV2(
      templateSlug: { eq: $templateSlug }
      node_locale: { eq: $lang }
    ) {
      ... on ContentfulPageExtraConfigsV2 {
        ...PageExtraConfigsV2
      }
    }
  }
`;
